"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordFinanceService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordFinanceService extends fetch_client_1.FetchClient {
  constructor(baseUrl, applicationId) {
    if (CordFinanceService.instance) {
      return CordFinanceService.instance;
    }
    super();
    this.applicationId = '';
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    if (applicationId) {
      this.applicationId = applicationId;
    }
    CordFinanceService.instance = this;
  }
  // Application
  createApplication() {
    return this.post('application/create', null);
  }
  createApplicationWithConsent(userId) {
    return this.post(`application/create/${userId}`, null);
  }
  getApplication() {
    return this.get('application/true');
  }
  updateApplication(data) {
    return this.post('application', data);
  }
  getApplicationById(applicationId = this.applicationId) {
    return this.get(`application/${applicationId}`);
  }
  searchApplications(queryObj) {
    return this.post('graphQl/search', queryObj);
  }
  promoteApplication() {
    return this.post('application/promote', null);
  }
  assignApplication(userId, applicationId = this.applicationId) {
    return this.patch('application/assign/' + applicationId + '/' + userId, null);
  }
  assignAdminToApplication(adminId, applicationId = this.applicationId) {
    return this.patch('application/' + applicationId + '/admin/' + adminId, null);
  }
  deleteApplication(applicationId = this.applicationId) {
    return this.delete(`application/${applicationId}`);
  }
  updateApplicationHDN(data, applicationId = this.applicationId) {
    return this.patch(`application/${applicationId}/hdn`, data);
  }
  authorizeApplication(data) {
    return this.post('application/authorize', data);
  }
  revokeApplication(data) {
    return this.post('application/revoke', data);
  }
  //Company
  saveCompanies(companies) {
    return this.post('companies', companies);
  }
  getCompanies(applicationId = this.applicationId) {
    return this.get('companies', applicationId);
  }
  deleteCompanies(companyId) {
    return this.delete('companies', companyId);
  }
  // Close
  closeApplicationDossier(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/close/dossier`, null);
  }
  getCloseApplicationStipulations(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/close/stipulations`);
  }
  updateCloseApplicationStipulation(data, applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/close/document`, data);
  }
  downloadCloseApplicationDocuments(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/close/downloadDocuments`, null);
  }
  // Persons
  getPersons(applicationId = this.applicationId) {
    return this.get('persons', applicationId);
  }
  savePersons(persons) {
    return this.post('persons', persons);
  }
  deletePerson(id) {
    return this.delete('persons', id);
  }
  // Legal
  deleteLegalPerson(id) {
    return this.delete(`legalPersons/${id}`);
  }
  // Incomes
  getIncomes(applicationId = this.applicationId) {
    return this.get('incomes', applicationId);
  }
  saveIncomes(incomes) {
    return this.post('incomes', incomes);
  }
  deleteIncome(id) {
    return this.delete('incomes', id);
  }
  // Assets
  getAssets(applicationId = this.applicationId) {
    return this.get('assets', applicationId);
  }
  saveAssets(assets) {
    return this.post('assets', assets);
  }
  deleteAsset(id) {
    return this.delete('assets', id);
  }
  // Receivable Loans
  getReceivableLoans(applicationId = this.applicationId) {
    return this.get('receivableloans', applicationId);
  }
  saveReceivableLoan(receivableLoans) {
    return this.post('receivableloans', receivableLoans);
  }
  deleteReceivableLoan(id) {
    return this.delete('receivableloans', id);
  }
  deleteAllReceivableLoans(applicationId = this.applicationId) {
    return this.delete('receivableloans/all', applicationId);
  }
  // Real Estates
  getRealEstates(applicationId = this.applicationId) {
    return this.get('realestates', applicationId);
  }
  saveRealEstates(realEstate) {
    return this.post('realestates', realEstate);
  }
  deleteRealEstate(id) {
    return this.delete('realestates', id);
  }
  // Mortgages
  getMortgages(applicationId = this.applicationId) {
    return this.get('mortgages', applicationId);
  }
  saveMortgages(mortgages) {
    return this.post('mortgages', mortgages);
  }
  deleteMortgage(id) {
    return this.delete('mortgages', id);
  }
  deleteAllMortgages(applicationId, flag = true) {
    return this.delete(`mortgages/all/${applicationId}?deleteAll=${flag}`);
  }
  deleteLoanPart(id, applicationId = this.applicationId) {
    return this.delete('loanparts', applicationId + '/' + id);
  }
  // Loans
  getLoans(applicationId = this.applicationId) {
    return this.get('loans', applicationId);
  }
  saveLoans(loans) {
    return this.post('loans', loans);
  }
  deleteLoan(id) {
    return this.delete('loans', id);
  }
  // Pensions
  getPensions(applicationId = this.applicationId) {
    return this.get('pensions', applicationId);
  }
  savePensions(pensions) {
    return this.post('pensions', pensions);
  }
  deletePension(id) {
    return this.delete('pensions', id);
  }
  // Expenses
  getExpenses(applicationId = this.applicationId) {
    return this.get('expenses', applicationId);
  }
  saveExpenses(expenses) {
    return this.post('expenses', expenses);
  }
  deleteExpense(id) {
    return this.delete('expenses', id);
  }
  //Insurances
  getInsurances(applicationId = this.applicationId) {
    return this.get('insurances', applicationId);
  }
  saveInsurances(insurances) {
    return this.post('insurances', insurances);
  }
  deleteInsurance(id) {
    return this.delete('insurances', id);
  }
  // Annuity
  getAnnuities(applicationId = this.applicationId) {
    return this.get('annuity', applicationId);
  }
  saveAnnuities(annuities) {
    return this.post('annuity', annuities);
  }
  deleteAnnuity(id) {
    return this.delete('annuity', id);
  }
  // Goals
  getGoals(applicationId = this.applicationId) {
    return this.get('goals', applicationId);
  }
  saveGoals(goals) {
    return this.post('goals', {
      Goals: goals
    });
  }
  deleteGoal(id) {
    return this.delete('goals', id);
  }
  // Pension solutions
  getPensionSolutions(applicationId = this.applicationId) {
    return this.get('pensionsolutions', applicationId);
  }
  savePensionSolutions(pensionSolutions) {
    return this.post('pensionsolutions', pensionSolutions);
  }
  deletePensionSolution(id) {
    return this.delete('pensionsolutions', id);
  }
  // Nibud
  getExpensesFromNibud(period, applicationId = this.applicationId) {
    return this.get('nibud', applicationId + '/' + period);
  }
  // Ockto
  getOcktoStatus(applicationId = this.applicationId) {
    return this.get('ockto/ocktoStatus', applicationId);
  }
  /**
   * @description Fetches a QR code from Ockto
   * @param applicationId
   * @param [TACCode=false] when set to true, a TAC code will be requested when available
   * @param [options={}] Additional options to the startocktosession request
   */
  startOcktoSession(applicationId = this.applicationId, TACCode = false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options = {}) {
    var _a, _b;
    options.ApplicationID = applicationId;
    if (TACCode) {
      if (/Android/i.test(navigator.userAgent)) {
        options.OSName = 'Android';
        options.OSVersion = (_a = /Android (.*);/i.exec(navigator.userAgent)) === null || _a === void 0 ? void 0 : _a[1];
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        options.OSName = 'iOS';
        options.OSVersion = (_b = /OS (.*?) like /i.exec(navigator.userAgent)) === null || _b === void 0 ? void 0 : _b[1].split('_').join('.');
      }
    }
    return this.post('ockto/StartCFOcktoSession', options);
  }
  GetOcktoDataSourcesAvailability() {
    return this.get('ockto/GetDatasourceAvailability');
  }
  // Opal
  getRetirementDate(dob) {
    return this.post('opal/retirement', {
      DateOfBirth: dob
    });
  }
  getWealth(applicationId = this.applicationId) {
    return this.get('opal/Overview', applicationId);
  }
  calculateFinalResponse(applicationId = this.applicationId) {
    return this.post('opal/CalculateFinalResponse', {
      ApplicationID: applicationId
    });
  }
  calculateDashboardFinalResponse(applicationId = this.applicationId) {
    return this.get('opal/Calculate/Dashboard', applicationId);
  }
  calculatePlaygroundFinalResponse(applicationId = this.applicationId) {
    return this.get('opal/Calculate/Playground', applicationId);
  }
  getOptimizedGoal(optimizerGoalType, goalId, applicationId = this.applicationId) {
    return this.get(`opal/Optimise/${optimizerGoalType}/${applicationId}/${goalId}`);
  }
  getOptimizedScenario(scenario, calculationType, applicationId = this.applicationId) {
    return this.get(`opal/optimise/${scenario}/${applicationId}?calculationType=${calculationType}`);
  }
  // Figlo
  calculateFinalResponseFiglo(applicationId = this.applicationId) {
    return this.get('figlo/Calculate', applicationId);
  }
  generateReportFiglo(applicationId = this.applicationId) {
    return this.get('figlo/LatestReport', applicationId);
  }
  saveApplicationToFiglo(applicationId = this.applicationId) {
    return this.post('figlo/save/' + applicationId, '');
  }
  getRetirementDateFiglo(dob) {
    return this.post('figlo/RetirementDate', {
      DateOfBirth: dob
    });
  }
  getClientFileFiglo(applicationId = this.applicationId) {
    return this.get('figlo/ClientFile', applicationId);
  }
  // GDPR
  saveConsent(data) {
    return this.post('gdpr/authorize', data);
  }
  revokeConsent(data) {
    return this.post('gdpr/revoke', data);
  }
  getPurpose(applicationId = this.applicationId) {
    return this.get('gdpr/getPurpose', applicationId);
  }
  updatePurpose(data) {
    return this.put('gdpr/updatePurpose', data);
  }
  verifyApplication(data) {
    return this.post('gdpr/verify', data);
  }
  getLatestActivePolicies(applicationId = this.applicationId, policyReference) {
    let endpointUrl = 'policy/active?';
    if (applicationId) endpointUrl += `ApplicationId=${applicationId}&`;
    if (policyReference) endpointUrl += `PolicyReference=${policyReference}`;
    return this.get(endpointUrl);
  }
  getPolicyContent(policyReference, policyVersion) {
    return this.get(`policyContent/${policyReference}/${policyVersion}`);
  }
  // Schema
  getSchema(entityType) {
    return this.get('schema', entityType);
  }
  sendSMS(phoneNumber) {
    return this.post('sms/sendOcktoLink', {
      PhoneNumber: phoneNumber
    });
  }
  /**
   * This will create a DocDigi object on given application.
   * @param applicationId
   * @returns void
   */
  createDocDigiAdviceOnApplication(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/docdigiAdvice`, null);
  }
  /**
   * This will return a DocDigi object on given application.
   * @param applicationId
   * @returns DocDigiAdviceResponse
   */
  getDocDigiAdviceOnApplication(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/docdigiAdvice`);
  }
  /**
   * This will update DocDigi object on given application.
   * @param applicationId
   * @returns void
   */
  updateDocDigiAdviceOnApplication(applicationId = this.applicationId) {
    return this.patch(`applications/${applicationId}/docdigiAdvice`, null);
  }
  /**
   * This will sync CDM.DocDigiData object on given application.
   * @param applicationId
   * @returns void
   */
  putDocDigiAdviceOnApplication(applicationId = this.applicationId) {
    return this.put(`applications/${applicationId}/docdigiAdvice`, null);
  }
  /**
   * This will initiate and calculate MortgageCosts in DocDigi on given application.
   * @param applicationId
   * @returns void
   */
  calculateMortgageCostsByDocDigi(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/docdigiAdvice/calculateMortgageCosts`, null);
  }
  /**
   * This will return calculated MortgageCosts from DocDigi on given application.
   * @param applicationId
   * @returns DocDigiMortgageCostsResponse
   */
  getCalculateMortgageCostsByDocDigi(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/docdigiAdvice/mortgageCosts`);
  }
  /**
   * This will initiate and calculate LifeEvents for Risk Profile in DocDigi on given application.
   * @param applicationId
   * @returns void
   */
  calculateLifeEventsByDocDigi(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/docdigiAdvice/calculateIncomeLifeEvents`, null);
  }
  /**
   * This will return calculated LifeEvents from DocDigi on given application.
   * @param applicationId
   * @returns DocDigiLifeEventsResponse
   */
  getCalculateLifeEventsByDocDigi(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/docdigiAdvice/incomeLifeEvents`);
  }
  /**
   * This will initiate and calculate Insurance Premium for Risk Profile in DocDigi on given application.
   * @param applicationId
   * @returns void
   */
  calculateInsurancePremiumByDocDigi(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/docdigiAdvice/calculateInsurancePremium`, null);
  }
  /**
   * This will return calculated Insurance Premium from DocDigi on given application.
   * @param applicationId
   * @returns DocDigiInsurancePremiumResponse
   */
  getInsurancePremiumByDocDigi(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/docdigiAdvice/insurancePremium`);
  }
  /**
   * This will generate Advice Report from DocDigi on given application.
   * @param applicationId
   * @returns void
   */
  generateAdviceReportByDocDigi(applicationId = this.applicationId) {
    return this.post(`applications/${applicationId}/docdigiAdvice/generateAdviceReport`, null);
  }
  /**
   * This will return base64string which contains Advice Report from DocDigi on given application.
   * @param applicationId
   * @returns AdviceReportResponse
   */
  getAdviceReportByDocDigi(applicationId = this.applicationId) {
    return this.get(`applications/${applicationId}/docdigiAdvice/AdviceReport`);
  }
}
exports.CordFinanceService = CordFinanceService;
CordFinanceService.instance = null;
